export default __webpack_public_path__ + "images/0xd8ca34fd379d9ca3c6ee3b3905678320f5b45195.png";